// extracted by mini-css-extract-plugin
module.exports = {"productLink":"product-card-link_productLink__buV1I"};